import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import Contact from "./sections/Contact";
import OurClubDetails from "./sections/OurClubDetails";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <StartYourJourney />
      <Contact />
      <OurClubDetails />
      <Footer />
    </div>;
}